'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../node_modules/classnames/index.js');

var index = require('../../node_modules/prop-types/index.js');

var Button = require('../../primitives/Button/Button.js');

var Hero = require('../../primitives/Hero/Hero.js');

var useExternalLink = require('../../utilities/hooks/useExternalLink.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var Banner = function Banner(props) {
  var border = props.border,
      btnColor = props.btnColor,
      btnLink = props.btnLink,
      btnText = props.btnText,
      category = props.category,
      className = props.className,
      contentMaxWidth = props.contentMaxWidth,
      contentSide = props.contentSide,
      dateText = props.dateText,
      iframe = props.iframe,
      featuredImage = props.featuredImage,
      secondBtnText = props.secondBtnText,
      secondBtnLink = props.secondBtnLink,
      secondBtnTarget = props.secondBtnTarget,
      subtitle = props.subtitle,
      target = props.target,
      thirdBtnText = props.thirdBtnText,
      thirdBtnLink = props.thirdBtnLink,
      thirdBtnTarget = props.thirdBtnTarget,
      title = props.title;
  var bannerClasses = index$1['default']('lanl-banner', className);
  var contentClasses = index$1['default']('lanl-banner-content', "lanl-banner-content-".concat(contentSide), contentMaxWidth && 'lanl-banner-content-width', className);

  var renderCategory = function renderCategory() {
    return typeof category === 'string' ? /*#__PURE__*/React__default['default'].createElement("p", {
      className: "lanl-banner-category"
    }, category) : /*#__PURE__*/React__default['default'].createElement("span", {
      className: "category-logo"
    }, category);
  };

  var renderBorder = function renderBorder() {
    var borderClass = index$1['default']('lanl-banner-border', "bg-".concat(btnColor));
    return border ? /*#__PURE__*/React__default['default'].createElement("div", {
      className: borderClass
    }) : null;
  };

  var renderTitle = function renderTitle() {
    return typeof title === 'string' ? /*#__PURE__*/React__default['default'].createElement("h1", {
      className: "display-1 lanl-banner-title ".concat(subtitle ? 'title-line-clamp' : '')
    }, btnLink ? /*#__PURE__*/React__default['default'].createElement(useExternalLink.GatsbyLink, {
      className: "text-white",
      href: btnLink,
      target: target
    }, title) : title) : /*#__PURE__*/React__default['default'].createElement("span", {
      className: "title-image"
    }, title);
  };

  var renderContent = function renderContent() {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: bannerClasses,
      "data-testid": "lanl-banner"
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: contentClasses
    }, renderCategory(), renderTitle(), dateText && /*#__PURE__*/React__default['default'].createElement("p", {
      className: "lanl-banner-date"
    }, dateText), /*#__PURE__*/React__default['default'].createElement("p", {
      className: "lanl-banner-subtitle"
    }, subtitle), btnText && btnLink && /*#__PURE__*/React__default['default'].createElement(Button.Button, {
      color: btnColor,
      className: "lanl-banner-btn",
      href: btnLink,
      target: target
    }, btnText, /*#__PURE__*/React__default['default'].createElement("span", {
      className: "sr-only"
    }, "about the article: ", title)), secondBtnText && secondBtnLink && /*#__PURE__*/React__default['default'].createElement(Button.Button, {
      color: "white",
      className: "lanl-banner-btn lanl-banner-btn-more lanl-btn-second",
      href: secondBtnLink,
      target: secondBtnTarget,
      outline: true,
      arrow: false
    }, secondBtnText), thirdBtnText && thirdBtnLink && /*#__PURE__*/React__default['default'].createElement(Button.Button, {
      color: "white",
      className: "lanl-banner-btn lanl-banner-btn-more lanl-banner-btn-third",
      href: thirdBtnLink,
      arrow: false,
      target: thirdBtnTarget,
      outline: true
    }, thirdBtnText)));
  };

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, featuredImage && /*#__PURE__*/React__default['default'].createElement(Hero.Hero, {
    img: featuredImage,
    className: iframe ? ' hero-iframe-experience' : ''
  }, renderContent()), iframe && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "iframe-container",
    "data-testid": "iframe-container"
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: iframe
    }
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "iframe-content"
  }, renderContent())), renderBorder());
};

Banner.defaultProps = {
  border: false,
  btnColor: 'secondary',
  btnText: 'Read Story',
  contentSide: 'left',
  contentMaxWidth: true,
  secondBtnTarget: '',
  target: '',
  thirdBtnTarget: ''
};
Banner.propTypes = {
  featuredImage: index['default'].string.isRequired,
  title: index['default'].string.isRequired,
  border: index['default'].bool,
  btnColor: index['default'].string,
  btnLink: index['default'].string,
  btnText: index['default'].string,
  category: index['default'].oneOfType([index['default'].node, index['default'].string]),
  className: index['default'].string,
  contentMaxWidth: index['default'].bool,
  contentSide: index['default'].oneOf(['left', 'right', 'center']),
  dateText: index['default'].string,
  iframe: index['default'].node,
  secondBtnLink: index['default'].string,
  secondBtnTarget: index['default'].string,
  secondBtnText: index['default'].string,
  subtitle: index['default'].string,
  target: index['default'].string,
  thirdBtnLink: index['default'].string,
  thirdBtnTarget: index['default'].string,
  thirdBtnText: index['default'].string
};
exports.Banner = Banner;
exports['default'] = Banner;